module.exports = __webpack_public_path__ + "img/folder-x.910f7c34.svg";